import { isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, type OnInit, PLATFORM_ID, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ArrowRight, BriefcaseBusiness, Key, LucideAngularModule } from 'lucide-angular';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/auth/services/auth.service';
import { MicrosoftTeamsIntegrationService } from '../../../core/services/microsoft-teams-integration.service';
import { LoginButtonComponent } from '../components/login-button.component';
import { LoginErrorComponent } from '../components/login-error.component';
import { LoginLoadingComponent } from '../components/login-loading.component';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  imports: [
    LucideAngularModule,
    LoginLoadingComponent,
    LoginErrorComponent,
    LoginButtonComponent,
    FormsModule,
    NgOptimizedImage,
  ],
})
export class LoginComponent implements OnInit {
  protected readonly MockLoginIcon = Key;
  protected readonly Briefcase = BriefcaseBusiness;
  protected readonly ArrowRight = ArrowRight;

  private readonly platformId = inject(PLATFORM_ID);
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly microsoftTeamsIntegrationService = inject(MicrosoftTeamsIntegrationService);

  protected readonly passedError = signal<string | null>(null);
  protected readonly passedCause = signal<string | null>(null);
  protected readonly isAppInitializing = computed(() => {
    console.log(`App initializing: ${this.microsoftTeamsIntegrationService.isInitializing()}`);
    if (this.microsoftTeamsIntegrationService.isInitializing() === undefined) {
      return true;
    }
    return this.microsoftTeamsIntegrationService.isInitializing();
  });
  protected readonly isMicrosoftTeamsEnvironment = computed(() => {
    console.log(`Teams environment: ${this.microsoftTeamsIntegrationService.isMicrosoftTeamsEnvironment()}`);
    return this.microsoftTeamsIntegrationService.isMicrosoftTeamsEnvironment();
  });
  protected readonly isLoginStarted = signal<boolean>(false);
  protected devToken = '';

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.passedError.set(this.route.snapshot.queryParamMap.get('error'));
      this.passedCause.set(this.route.snapshot.queryParamMap.get('cause'));
    }
  }

  login(): void {
    this.isLoginStarted.set(true);
    if (environment.production) {
      this.authService.initiateFederatedAuthentication();
    } else {
      this.authService.loginWithStrapiToken(this.devToken).then();
    }
  }

  isProduction(): boolean {
    return environment.production;
  }
}
